// extracted by mini-css-extract-plugin
export default {"modalHeader":"FavoritesModalHeader__modalHeader___Jqwnd"};